/*
 * readMoreClamp — line-clamped description with a "Read More" toggle for the
 * detail-page intros (floorplans / packages / display homes).
 *
 * Server-side clamp keeps CLS at zero; on init we measure whether the body
 * overflows its clamped box and only then reveal the toggle. `.no-js` unclamps
 * (see the .no-js rules), so the copy is always fully readable without JS.
 *
 * Alpine CSP build — every template binding is a single named method call or
 * property/getter read (no inline object x-data, assignments, or ternaries).
 * The markup expects:
 *   x-ref="body"   the clamped copy element (measured for overflow)
 *   .mh-detail-intro__desc-body--expanded   the unclamp class
 */
export default function readMoreClamp() {
    return {
        expanded: false,
        overflows: false,

        init() {
            const body = this.$refs.body;
            if (!body) return;
            // +1 absorbs sub-pixel rounding so a perfectly-fitting clamp doesn't
            // falsely register as overflowing.
            this.overflows = body.scrollHeight > body.clientHeight + 1;
        },

        toggle() {
            this.expanded = !this.expanded;
        },

        // Getters back the CSP-build bindings that can't hold expressions.
        get showToggle() {
            return this.overflows || this.expanded;
        },

        get label() {
            return this.expanded ? 'Read Less' : 'Read More';
        },

        get bodyClass() {
            return this.expanded ? 'mh-detail-intro__desc-body--expanded' : '';
        },
    };
}
